import React from "react";
import styled from "styled-components";
import { LineDivider, device } from "../styled";

const Container = styled.div`
  background-color: #000;
  border-top: 5px #000 solid;
  border-bottom: 5px #000 solid;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 100vw;

    @media ${device.tablet} {
      width: 30%;
    }
  }
`;

const Logo = () => {
  return (
    <Container>
      <LineDivider />
      <img src={"/artist-logo-texts.png"} alt="logo" />
      <LineDivider />
    </Container>
  );
};

export default Logo;
